module.exports = __webpack_public_path__ + "static/logo-aaa-3dee27f1039a63647925a94ae62a5e61.png";